module.exports = __webpack_public_path__ + "static/media/option9.feb82d02.png";